import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17d3623a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "newClubMember" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 center mb-4" }, "Opret medlem", -1))
const _hoisted_3 = { class: "newMemberContainer" }
const _hoisted_4 = { class: "layout gutter--lg newMemberInfoContainer" }
const _hoisted_5 = { class: "row justify--space-around align--center" }
const _hoisted_6 = { class: "flex md6 xs12" }
const _hoisted_7 = { class: "flex md6 xs12" }
const _hoisted_8 = { class: "flex md6 xs12" }
const _hoisted_9 = { class: "flex md6 center xs12" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Check Brugernavns status")
const _hoisted_11 = { class: "flex md6 xs12" }
const _hoisted_12 = { class: "flex md6 xs12" }
const _hoisted_13 = { class: "flex md4 xs6" }
const _hoisted_14 = { class: "flex md4 xs6" }
const _hoisted_15 = { class: "flex md6 xs12" }
const _hoisted_16 = { class: "flex md3 xs6" }
const _hoisted_17 = { class: "flex md3 xs6" }
const _hoisted_18 = { class: "flex md6 xs12" }
const _hoisted_19 = { class: "flex md6 xs12" }
const _hoisted_20 = { class: "flex md3 xs6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--space-around align--center" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--space-around align--center" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--space-around align--center" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--space-around align--center" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center align--center" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("i", null, "Felter markeret med * skal udfyldes")
    ])
  ])
], -1))
const _hoisted_27 = { class: "row justify--center mt-4" }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Opret medlem")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Spiller er oprettet", -1))
const _hoisted_32 = { class: "layout gutter--lg" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "flex" }
const _hoisted_35 = { class: "newMemberModal center" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "flex" }
const _hoisted_38 = { class: "newMemberModal center" }
const _hoisted_39 = { class: "row justify--center" }
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Til kassen")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Tilbage")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Opret nyt medlem")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_form = _resolveComponent("va-form")!
  const _component_it_modal = _resolveComponent("it-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_va_form, { ref: "form" }, {
          default: _withCtx(() => [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "text",
                    modelValue: _ctx.memberData.memberFirstName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.memberData.memberFirstName) = $event)),
                    label: "Fornavn*",
                    rules: [(v) => v.length > 1 || 'Der mangler et fornavn']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "text",
                    modelValue: _ctx.memberData.memberLastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.memberData.memberLastName) = $event)),
                    label: "Efternavn*",
                    rules: [(v) => v.length > 1 || 'Der mangler et efternavn']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "text",
                    modelValue: _ctx.memberData.memberUserName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.memberData.memberUserName) = $event)),
                    label: "Vælg et unikt brugernavn*",
                    rules: [(v) => v.length > 1 || 'Der mangler et brugernavn'],
                    success: _ctx.userNameAvailable === true,
                    error: _ctx.userNameAvailable === false
                  }, null, 8, ["modelValue", "rules", "success", "error"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_va_button, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkUserName()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "password",
                    modelValue: _ctx.memberData.memberPassword,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.memberData.memberPassword) = $event)),
                    name: "new-password",
                    autocomplete: "on",
                    label: "Vælg en adgangskode*",
                    rules: [(v) => _ctx.passwordTest(v) || 'Adgangskoden skal være på minimum 8 tegn, indeholde tal, specialtegn, store og små bogstaver']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "password",
                    modelValue: _ctx.memberData.memberRepeatPassword,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.memberData.memberRepeatPassword) = $event)),
                    name: "new-password",
                    autocomplete: "on",
                    label: "Gentag adgangskoden",
                    rules: [(v) => v === _ctx.memberData.memberPassword || 'Adgangskoderne er ikke ens']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "date",
                    modelValue: _ctx.memberData.memberBirthDate,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.memberData.memberBirthDate) = $event)),
                    label: "Fødselsdag*",
                    rules: [(v) => v !== '' || 'Fødselsdagen mangler']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_va_select, {
                    bordered: "",
                    modelValue: _ctx.genderStringValue,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.genderStringValue) = $event)),
                    options: _ctx.genderStringOptions,
                    label: "Køn*",
                    rules: [(v) => v !== 'Vælg køn' || 'Vælg venligst køn']
                  }, null, 8, ["modelValue", "options", "rules"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "text",
                    modelValue: _ctx.memberData.memberAddress,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.memberData.memberAddress) = $event)),
                    label: "Vej og husnr."
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    class: "center",
                    type: "number",
                    modelValue: _ctx.memberData.memberZipCode,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.memberData.memberZipCode) = $event)),
                    onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cityZipCodeInputFocus = 2)),
                    label: "Postnr."
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "text",
                    modelValue: _ctx.memberData.memberCity,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.memberData.memberCity) = $event)),
                    onFocus: _cache[12] || (_cache[12] = ($event: any) => (_ctx.cityZipCodeInputFocus = 1)),
                    label: "By"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "number",
                    modelValue: _ctx.memberData.memberTelephone,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.memberData.memberTelephone) = $event)),
                    label: "Telefon"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    modelValue: _ctx.memberData.memberEmail,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.memberData.memberEmail) = $event)),
                    type: "email",
                    label: "Email*",
                    rules: [(v) => _ctx.testLegalEmail(v) || 'Vær venlig at angive en email']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_va_checkbox, {
                    label: "Tilkøb licens samtidigt",
                    modelValue: _ctx.buyLicens,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.buyLicens) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _hoisted_24,
              _hoisted_25
            ])
          ]),
          _: 1
        }, 512),
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.$refs.form.validate();_ctx.createMember()})
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (this.clearMemberData()))
            }, {
              default: _withCtx(() => [
                _hoisted_30
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.createNewMemberModal,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.createNewMemberModal) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_31
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.memberData.memberFirstName + ' ' + _ctx.memberData.memberLastName) + " er blevet oprettet, og har fået licensnummer " + _toDisplayString(_ctx.memberData.memberLicense) + ".", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("p", _hoisted_38, "En mail, med alle oplysninger er blevet sent til " + _toDisplayString(_ctx.memberData.memberEmail), 1)
            ])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            (_ctx.buyLicens)
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 0,
                  class: "mr-4",
                  color: "success",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.toCheckOut()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_41
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_va_button, {
                  key: 1,
                  class: "mr-4",
                  color: "success",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.toMemberPortalMain()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_42
                  ]),
                  _: 1
                })),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.createNewMemberModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_43
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}